import { useSystemTransfer } from './hooks/usePointsTransfer';
import { SystemTransferTable } from './table';

const SystemTransfer = () => {
  const { systemTransferdata } = useSystemTransfer();
  return <SystemTransferTable data={systemTransferdata} />;
};

export default SystemTransfer;
